import { HStack, Link, Text } from '@chakra-ui/react';
import { InsuranceDetails } from '@web-app/graphql/healthie/queries/get-client-insurance-details/types';
import {
  getPatientHref,
  PatientProfileSource,
} from '@web-app/utils/navigation/patient-href';

type Props = {
  clientId: string;
  data: InsuranceDetails;
};

/**
 * V2 version of BenefitsHeader for CallV2 layout.
 * Removed "Insurance Information" header as it's handled by the tab/section title.
 */
export function BenefitsHeaderV2({ data, clientId }: Props) {
  const patientLink = getPatientHref(clientId, PatientProfileSource.InCall);

  return (
    <HStack justifyContent="space-between" data-testid="benefits-header">
      <Text isTruncated fontWeight={600} width="80%">
        {data?.insurancePlan?.payerName ||
          (data?.hasSelfPay ? 'Cash pay' : 'No coverage')}
      </Text>
      <Link
        color="orange.500"
        textDecoration="underline"
        target="_blank"
        href={patientLink}
      >
        More info
      </Link>
    </HStack>
  );
}

BenefitsHeaderV2.displayName = 'BenefitsHeaderV2';
